<template>
  <div class="index">
    <!-- <Header ref="header" title="自然人用户注册" :back="true" left="" /> -->
    <div class="windowmain">
      <div class="boxmain">
        <p class="boxTitle"> <span style="margin-right:12px;color:#00599c;display: flex;align-items: center;"><img style="width:18px;margin-right:2px" src="@/views/image/userregister/icon_user.png" alt="" srcset=""> 自然人注册:</span> 2/2 设置用户名密码</p>
        <van-form validate-first ref="form">
          <div class="boxinput">
            <div class="filed-vertical">
              <div class="lable"><span>*</span>用户名</div>
              <van-field
                autocomplete="off"
                v-model="certName"
                class="input"
                :rules="checkCertName"
                clearable
                placeholder="请填写用户名"
              />
            </div>
            <div class="filed-vertical">
              <div class="lable"><span>*</span>登录密码</div>
              <van-field
                v-model="pwd"
                autocomplete="new-password"
                type="password"
                class="input"
                :rules="checkPwd"
                clearable
                maxlength="20"
                v-show="downIcon1"
                @click-right-icon="eye1"
                right-icon="eye"
                error-message
                placeholder="请输入密码"
              >
                <template #right-icon>
                  <img style="width:20px;position: relative;top: 4px;" src="@/views/image/userregister/eye_close.png" alt="" >
                </template>
              </van-field>
              <van-field
                v-model="pwd"
                type="text"
                class="input"
                maxlength="20"
                :rules="checkPwd"
                v-show="!downIcon1"
                clearable
                @click-right-icon="eye1"
                right-icon="eye-o"
                error-message
                placeholder="请输入密码"
              >
               <template #right-icon >
                  <img style="width:20px;position: relative;top: 4px;" src="@/views/image/userregister/eye_show.png" alt="" >
                </template>
              </van-field>
            </div>

            <div class="filed-vertical">
              <div class="lable"><span>*</span>确认登录密码</div>
              <van-field
                v-model="againPwd"
                type="password"
                autocomplete="new-password"
                class="input"
                maxlength="20"
                clearable
                v-show="downIcon"
                :rules="checkAgainPwd"
                @click-right-icon="eye"
                right-icon="eye"
                error-message
                placeholder="请再次输入密码"
              >
                <template #right-icon>
                  <img style="width:20px;position: relative;top: 4px;" src="@/views/image/userregister/eye_close.png" alt="" >
                </template>
              </van-field>
              <van-field
                v-model="againPwd"
                type="text"
                class="input"
                maxlength="20"
                v-show="!downIcon"
                :rules="checkAgainPwd"
                clearable
                @click-right-icon="eye"
                right-icon="eye-o"
                error-message
                placeholder="请再次输入密码"
              >
                <template #right-icon>
                  <img style="width:20px;position: relative;top: 4px;" src="@/views/image/userregister/eye_show.png" alt="" >
                </template>
              </van-field>
            </div>
          </div>
        </van-form>
      </div>

      <div style="margin: 22px">
        <van-button type="primary" class="btn3" size="large" @click="blackbtn()"
          >上一步</van-button
        >
        <van-button
               type="primary"
          style="width:100%;height:1.07rem;font-size: 0.426667rem"
          size="small"
          @click="fromSubmit()"
          >下一步</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import md5 from './md5.js'
import {
  Form,
  RadioGroup,
  Radio,
  Cell,
  CellGroup,
  Field,
  Col,
  Row,
  Button,
  Picker,
  Popup,
  Toast,
  DatetimePicker,
  NoticeBar,
} from "vant";

export default {
  name: "swuserregpsd",
  computed: {
    checkCertName(){
       // ✅ 复用同一个 rule 对象，防止 Vant 误触发校验
      const rule = this._checkCertName || (this._checkCertName = {});

      // ✅ 动态绑定 message
      rule.validator = this.validateInviteCode;
      rule.message = this.msg;
      rule.trigger = 'onBlur'; // ✅ 控制触发时机

      return [rule];
      // return  [
      //       {
      //         validator: this.validateInviteCode,
      //         message: this.msg,//"用户名可录入英文字母，数字和_",
      //          trigger: 'onBlur'
      //       },
      //     ];
      },
    checkPwd() {
      return [
        {
          required: true,
          message: "请输入登录密码",
          trigger: "onBlur",
        },
        {
          validator: (value) => {
            var pattern =
              /((^(?=.*[a-z])(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[a-z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\da-zA-Z\W]{8,16}$))/;
            return pattern.test(value);
          },
          message: "请使用8-16位数字、大写字母、小写字母、特殊字符中的三类及以上组合",
          trigger: "onBlur",
        },
      ];
    },
    checkAgainPwd() {
      return [
        {
          required: true,
          message: "请再次输入登录密码",
          trigger: "onBlur",
        },
        {
          validator: (value) => {
            var pattern =
              /((^(?=.*[a-z])(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[a-z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\da-zA-Z\W]{8,16}$))/;
            return pattern.test(value);
          },
          message:"请使用8-16位数字、大写字母、小写字母、特殊字符中的三类及以上组合",
          trigger: "onBlur",
        },
      ];
    },
  },
  data() {
    return {
      certName: "",
      pwd: "",
      againPwd: "",
      downIcon: true,
      downIcon1: true,
      statusBar: 0,
      msg: "请输入用户名",
      _checkCertName:null,
    };
  },
  mounted() {
    this.statusBar = this.$tool.statusBar(45);
  },

  methods: {
    validateInviteCode(value) {
      var that = this
      return new Promise((resolve) => {
        var pattern = /^[0-9a-zA-Z]{6,18}$/;
          if (value=='') {
            that.msg = '请填写用户名'
              return  resolve(false);
            }
          if (!pattern.test(value)) {
              that.msg = '请使用6-18位英文字母或字母与数字组合'
              return  resolve(false);
          }else{
              return resolve(true);
              // that.$http.post('/zsdyckserver/mb/user/checkUserName', {userName:value}).then((res) => {
              //     if (res.success) {
              //       return resolve(true);    
              //     }else{
              //         that.msg = res.msg
              //        return resolve(false);
              //     }
              //   })
          }

      })       

    },
    blackbtn() {
      this.$router.go(-1);
    },
    fromSubmit() {
      this.$refs.form.validate().then(() => {
        if (this.pwd != this.againPwd) {
          this.$toast("两次密码输入不一致，请确认");
          return;
        }
        this.$http.post('/zsdyckserver/mb/user/register', {
          userName:this.certName,password:md5.hexMD5(this.pwd),verifyKey:this.$route.query.verifyKey
        }).then((res) => {
          if (res.success) {
            console.log(111,'注册成功');
            this.$router.push({
              path: "/swuserregpsdend",
              query: {
                isLoginCred: res.data.isLoginCred?'true':'false',
                registerType: this.$route.query.registerType,
                userName:res.data.accountName
              },
            });
          } else {
            this.$toast(res.msg);
          }
        });
      });
      // this.$router.push({
      //     path: '/swuserregpsdend',

      //   });
    },
    eye() {
      console.log('eye');
      this.downIcon = !this.downIcon;
    },
    eye1() {
      console.log('eye1');
      this.downIcon1 = !this.downIcon1;
    },
  },

  components: {
    Header,
    [Field.name]: Field,
    [Button.name]: Button,
    [Form.name]: Form,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Col.name]: Col,
    [Row.name]: Row,
    [Button.name]: Button,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [DatetimePicker.name]: DatetimePicker,
    [NoticeBar.name]: NoticeBar,
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/public.scss";
@import "@/views/css/userindex.scss";
.index {
  box-sizing: border-box;
  height: 100%;
  background: #fff;
}
.windowmain {
  width: 100%;
  overflow-x: hidden;
  .boxTitle {
    font-size: 16px;
    width: 100%;
        display: flex;
    align-items: center;
    background: #f7f8fa;
    color: #333;
    font-weight: bold;
    padding: 12px 0px 10px 20px;
  }
  .boxmain {
    width: 100%;
  }
  .boxinput {
    margin: 0px 15px 0px 15px;
    height: auto;
    border-radius: 4px;
    background: #fff;
    padding: 10px;
    .filed-vertical {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      margin-bottom: 8px;
      .lable {
        font-size: 12px;
        color: #333;
      }
      .lable span {
        display: inline-block;
        color: #ee0a24;
        margin-right: 4px;
      }
      ::v-deep.van-cell {
        padding: 0px;
      }
      ::v-deep .van-cell .van-field__body {
        border: 1px solid #ddd;
        padding: 4px 9px;
        border-radius: 4px;
        margin-top: 6px;
      }
      ::v-deep .van-cell .van-field__body:hover {
        border: 1px solid #00599c;
        box-shadow: 0px 2px 5px 3px raga(0, 89, 156, 0.1);
      }

      // ::v-deep .van-field__control:focus{
      //   border: 1px solid #00599c;
      //   box-shadow:  0px 2px 5px 3px raga(0,89,156,0.10);
      // }
    }
  }

  .ftBton {
    padding: 0px 15px;
    font-size: 11px;
    color: #999;
  }
  ::v-deep .van-checkbox__icon {
    height: 0.9rem;
  }
  ::v-deep .van-checkbox__icon .van-icon {
    font-size: 11px;
  }
  ::v-deep .van-checkbox__label {
    color: #999;
    span {
      color: #096ac6;
    }
  }
}
</style>